import React from "react";
import Style from "./Home.module.scss";
import me from "../../img/self.png";
import classNames from "classnames";
import EmojiBullet from "./EmojiBullet";
import SocialIcon from "./SocialIcon";
import { Box, Container } from "@mui/material";
import { info } from "../../info/Info";

export default function Home() {
  return (
    <Container maxWidth="xl">
      <Box
        component={"main"}
        display={"flex"}
        flexDirection={{ xs: "column", md: "row" }}
        alignItems={"center"}
        justifyContent={"center"}
        minHeight={"calc(100vh - 175px)"}
      >
        <Box
          className={classNames(Style.avatar, Style.shadowed)}
          alt={"image of developer"}
          style={{ background: info.gradient }}
          component={"img"}
          src={me}
          width={{ xs: "35vh", md: "42vh" }}
          height={{ xs: "35vh", md: "42vh" }}
          borderRadius={"50%"}
          p={"0.75rem"}
          mb={{ xs: "1rem", sm: 0 }}
          mr={{ xs: 0, md: "2rem" }}
        />
        <Box>
          <h1>
            Hi, I'm{" "}
            <span
              style={{
                background: info.gradient,
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              {info.firstName}
            </span>
            <span className={Style.hand}>🤚</span>
          </h1>
          <h2>I'm {info.position}.</h2>
          <Box component={"ul"} p={"0.8rem"}>
            {info.miniBio.map((bio, index) => (
              <EmojiBullet key={index} emoji={bio.emoji} text={bio.text} />
            ))}
          </Box>
          <Box
            display={"flex"}
            gap={"1.5rem"}
            justifyContent={"left"}
            fontSize={{ xs: "2rem", md: "2.5rem" }}
          >
            <a href="https://www.instagram.com/mr.ahsan33/" target="_blank">
              <i
                className="fa fa-instagram"
                aria-hidden="true"
                style={{ colo: "#000", fontSize: "30px" }}
              />
            </a>
            <a href="https://www.instagram.com/mr.ahsan33/" target="_blank">
              <i
                className="fa fa-facebook"
                aria-hidden="true"
                style={{ colo: "#000", fontSize: "25px" }}
              />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=100060699962550"
              target="_blank"
            >
              <i
                className="fa fa-github"
                aria-hidden="true"
                style={{ colo: "#000", fontSize: "30px" }}
              />
            </a>
            <a
              href="https://www.linkedin.com/in/muhammad-ahsan-88575a237/"
              target="_blank"
            >
              <i
                className="fa fa-linkedin"
                aria-hidden="true"
                style={{ colo: "#000", fontSize: "30px" }}
              />
            </a>
          </Box>
        </Box>
      </Box>
    </Container>
  );
}
